import { appFetch } from "./httputil";
import type { User } from "./types";

export async function fetchCurrentUser(): Promise<User | null> {
  let rsp = await fetch("/auth/user");
  if (rsp.status === 401) {
    return null;
  }
  if (!rsp.ok) {
    throw new Error(`failed to fetch user: ${rsp.status}`);
  }
  return (await rsp.json()) as User;
}

export async function sendLoginEmail(email: string): Promise<void> {
  let uri = "/api/send_login_in_email?email=" + encodeURIComponent(email);
  let rsp = await appFetch(uri);
  if (!rsp.ok) {
    let body = await rsp.json().catch(() => ({}));
    throw new Error(body.error || "failed to send login email");
  }
}

export async function verifyLoginCode(code: string): Promise<void> {
  let uri = "/api/verify_login_code?code=" + encodeURIComponent(code);
  let rsp = await appFetch(uri);
  if (!rsp.ok) {
    let body = await rsp.json().catch(() => ({}));
    throw new Error(body.error || "failed to verify login code");
  }
}

export function logout() {
  window.location.href = "/auth/logout";
}
